<script>
  import { fade } from 'svelte/transition'
  import { PencilSquare, Trash } from 'svelte-bootstrap-icons'
  import { sortBy } from 'underscore'
  import { auth, currentSheet, locations, isAdmin } from './stores/root'
  import { exportSheet } from './stores/sheet'
  import { printSheet } from './printSheet.js'
  import ConfirmDeleteModal from './ConfirmDeleteModal.svelte'
  import ItemModal from './ItemModal.svelte'
  import InventoryFilter from './InventoryFilter.svelte'

  let showItemModal = false
  let deleteItem = null
  let editItem = null
  let vendorFilter = null
  let displayItems = null

  $: if (vendorFilter) {
    displayItems = $currentSheet.items.filter((item) =>
      item.details.some((detail) => detail.vendor.id === vendorFilter)
    )
  } else {
    displayItems = $currentSheet.items
  }

  function populateLocation(details, locationId) {
    const detail = details.find((d) => d.location == locationId)

    if (detail)
      return `
        <td data-locationId="${locationId}" data-detailId="${
        detail.id
      }" class="text-center d-none d-sm-table-cell">${
        detail.vendor
          ? detail.vendor.name
          : $currentSheet.closed
          ? 'MISSING VENDOR'
          : ''
      }</td>
        <td data-locationId="${locationId}" data-detailId="${
        detail.id
      }" class="px-0 d-none d-lg-table-cell location-qty">
      ${detail.qtyStart ? detail.qtyStart : ''}
      </td>
      `
    else
      return `
        <td data-locationId="${locationId}" class="text-center d-none d-sm-table-cell"></td>
        <td data-locationId="${locationId}" class="text-center d-none d-lg-table-cell location-qty"></td>
      `
  }
</script>

<div in:fade={{ duration: 500 }}>
  <div class="row mt-3 mb-3">
    <div class="col-12 col-sm-4 fs-3 mb-3 mb-sm-0">
      {$currentSheet.displayDate}
      {#if $currentSheet.closed}
        <span class="badge bg-secondary ms-2">Sheet Closed</span>
      {/if}
    </div>
    <div class="col-6 col-sm-4">
      <InventoryFilter bind:vendorFilter />
    </div>

    <div class="col-6 col-sm-4 d-flex justify-content-end mt-">
      {#if $isAdmin}
        <button
          class="btn btn-outline-secondary me-2"
          on:click={() => printSheet($currentSheet, $locations)}
          >Print Sheet</button
        >
      {/if}

      {#if $currentSheet.closed === false}
        <button class="btn btn-primary" on:click={(e) => (showItemModal = true)}
          >Add Item</button
        >
      {/if}

      {#if $currentSheet.closed === true && $currentSheet.exported === false}
        <button
          class="btn btn-primary"
          on:click={(e) => exportSheet($currentSheet.id)}>Export Data</button
        >
      {/if}
    </div>
  </div>

  <table class="table table-striped table-hover align-middle">
    <thead>
      <tr>
        <th scope="col">Item</th>
        {#each $locations as location}
          <th
            scope="col"
            class="text-center d-none d-sm-table-cell d-lg-none"
            colspan="1">{location.name}</th
          >

          <th scope="col" class="text-center d-none d-lg-table-cell" colspan="2"
            >{location.name}</th
          >
        {/each}
        <th />
      </tr>
    </thead>

    <tbody>
      {#each sortBy(displayItems, 'name') as item}
        <tr>
          <td class="item-name" style="max-width:250px;"
            >{item.name} - {item.variationName}
            {#if item.notes}
              <br />
              <small class="text-muted"
                ><strong>Notes: </strong>{item.notes}</small
              >
            {/if}
          </td>

          {#each $locations as location}
            {@html populateLocation(item.details, location.id)}
          {/each}

          <td class="text-center">
            <div class="btn-group">
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Actions
              </button>
              <ul class="dropdown-menu">
                <li>
                  <div
                    class="dropdown-item d-flex align-items-center"
                    on:click={(e) => {
                      editItem = item
                      showItemModal = true
                    }}
                  >
                    <PencilSquare class="me-2" />
                    Edit
                  </div>
                </li>
                {#if $isAdmin}
                  <li><hr class="dropdown-divider" /></li>
                  <li>
                    <div
                      class="dropdown-item d-flex align-items-center"
                      on:click={() => {
                        deleteItem = item
                      }}
                    >
                      <Trash class="me-2" />
                      Delete
                    </div>
                  </li>
                {/if}
              </ul>
            </div>
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
</div>

{#if deleteItem}
  <ConfirmDeleteModal
    item={deleteItem}
    on:close={() => {
      deleteItem = null
    }}
    on:delete={async (e) => {
      deleteItem = null
    }}
  />
{/if}

{#if showItemModal}
  <ItemModal
    {editItem}
    on:close={() => {
      showItemModal = false
      editItem = null
    }}
    on:save={() => {
      showItemModal = false
      editItem = null
    }}
  />
{/if}

<style lang="scss">
  :global(td.location-qty) {
    border-right: 1px solid lightgrey;
  }

  @media (min-width: 992px) {
    td.item-name {
      border-right: 1px solid lightgrey;
    }
  }
</style>
